// Public, low-cardinality vocabulary. Never use translated labels or user input.
export const ANALYTICS_EVENTS = Object.freeze({
  app_google_play_click:
    'Google Play: Installationslink geöffnet (keine Installation bestätigt)',
  app_apple_interest:
    'App Store: Coming-soon-Information bewusst geöffnet (kein Download)',
  program_comparison: 'Programmvergleich geöffnet',
  select_item: 'Paket ausgewählt',
  view_item: 'Paketdetails angesehen',
  add_to_cart: 'Paket in den Warenkorb gelegt',
  begin_checkout: 'Checkout mit Paket geöffnet',
  checkout_continue: 'Checkout fortgesetzt',
  login_start: 'Gültiges Loginformular abgesendet',
  login: 'Anmeldung vom Backend bestätigt',
  login_error: 'Anmeldeversuch fehlgeschlagen (ohne Fehlermeldung/Inhalt)',
  sign_up_start: 'Gültiges Registrierungsformular abgesendet',
  sign_up: 'Kontoerstellung vom Backend bestätigt',
  sign_up_error: 'Kontoerstellung fehlgeschlagen (ohne Fehlermeldung/Inhalt)',
  social_login_start: 'Social-Login bewusst gestartet',
  contact_start: 'Kontaktformular erstmals bearbeitet',
  generate_lead: 'Kontaktanfrage erfolgreich angenommen',
  contact_error: 'Kontaktanfrage konnte nicht gesendet werden',
  account_verified: 'E-Mail-Verifikation vom Backend bestätigt',
  purchase: 'Eigene bezahlte Bestellung anhand authentifizierter API bestätigt'
});
export const analyticsLanguages = new Set([
  'en',
  'de',
  'tr',
  'fr',
  'es',
  'pt',
  'it',
  'ar',
  'hi',
  'ur',
  'ru',
  'ja',
  'zh'
]);
export const analyticsLanguage = (value) =>
  analyticsLanguages.has(value) ? value : 'en';
export const analyticsMethod = (value) =>
  ['email', 'google', 'apple', 'facebook'].includes(value) ? value : undefined;
